export default {
  "betReport.title": "Bet Reports",
  "betReport.thead.userno": "UserNo",
  "betReport.thead.email": "Email",
  "betReport.thead.nickname": "Nickname",
  "betReport.thead.createTime": "Register Time",
  "betReport.thead.totalBetAmount": "Total Bet Amount",
  "betReport.thead.totalWinAmount": "Total Win Amount",
  "betReport.thead.totalGainAmount": "Total Gain Amount",
  "betReport.thead.winRatio": "Win Ratio",
  "betReport.thead.totalDepositAmount": "Total Deposit Amount",
  "betReport.thead.totalWithdrawAmount": "Total Withdraw Amount",
  "betReport.thead.vipLevel": "VIP Level",
  "betReport.tooltip.copyUserNo": "Copy UserNo: {text}",
  "betReport.copy.success": "Copy Success!",
  "depositRecord.tooltip.showUserDetails": "Show User Details",
};